/**
 * @generated SignedSource<<91a3193c89493963d3dd35ba27f37269>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CatalogHotspot_hotspot$data = {
  readonly dimensions: {
    readonly height: number | null;
    readonly left: number | null;
    readonly top: number | null;
    readonly width: number | null;
  } | null;
  readonly formType: string | null;
  readonly gaContemporaryTracking: string | null;
  readonly hotspotKey: string | null;
  readonly linkType: string | null;
  readonly " $fragmentType": "CatalogHotspot_hotspot";
};
export type CatalogHotspot_hotspot$key = {
  readonly " $data"?: CatalogHotspot_hotspot$data;
  readonly " $fragmentSpreads": FragmentRefs<"CatalogHotspot_hotspot">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CatalogHotspot_hotspot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hotspotKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HotspotDimensions",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "left",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "top",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gaContemporaryTracking",
      "storageKey": null
    }
  ],
  "type": "CatalogHotspotType",
  "abstractKey": null
};

(node as any).hash = "858d098b383584f017ee631964642093";

export default node;
